import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import DisclaimerMessageTable from '../Components/DisclaimerMessageTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedDisclaimer, setSelectedDisclaimer] = useState(undefined);
    const [selectedDisclaimerName, setSelectedDisclaimerName] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: messages, loading }, refetch] = useAxios("/internal/cobrand/disclaimer-messages");

    if (loading) return <Spinner className="absolute-center" label="Loading Domains..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Redirect Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <DisclaimerMessageTable
                domains={messages && messages.length > 0 ? messages.sort((a, b) => b.coBrandId - a.coBrandId) : []}
                setSelectedDisclaimer={setSelectedDisclaimer}
                setSelectedDisclaimerName={setSelectedDisclaimerName}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, name) => {
                    setSelectedDisclaimer(id);
                    setSelectedDisclaimerName(name || "");
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`internal/cobrand/disclaimer-message/delete/${selectedDisclaimer}/`}
                resourceName={selectedDisclaimerName}
                resourceType="disclaimer message"
                confirmationValue={selectedDisclaimerName || undefined}
            />
        </>
    );
};

export default DefaultPage;
